module.exports = __webpack_public_path__ + "img/bg6.d208d5e5.png";